import {Injectable} from '@angular/core';
import {Response} from '@angular/http';
import {AuthService} from 'auth/services/auth.service';
import 'rxjs/add/operator/catch';
import {Observable} from 'rxjs/Observable';

@Injectable()
export class LoginService {

  constructor(private authService: AuthService) { }

  public login(username: string, password: string): Observable<Response> {
    return this.authService.login(username, password)
      .catch((response: Response) => {
        if (response.status === 400) { // tslint:disable-line:no-magic-numbers
          throw new Error('Username/password must be set');
        } else if (response.status === 401) { // tslint:disable-line:no-magic-numbers
          throw new Error('Username or password incorrect');
        } else if (response.status === 0) {
          throw new Error('Could not connect to backend');
        }

        throw new Error(response.statusText);
      });
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/login/services/login.service.ts